import { route } from 'preact-router';
import { useState, useEffect, useRef, useCallback } from 'preact/hooks';
import { useTranslation } from 'react-i18next';
import { isAdmin, isSuperAdmin, user, logout } from '../stores/auth.store';
import { categories } from '../stores/category.store';
import { api } from '../api/client';
import { SkeletonBar, Button, Input } from './ui';
// LanguageSelector removido — idioma agora fica no menu do perfil
import { T, CT } from '../styles/tokens';
import { useTheme } from '../hooks/useTheme';
import { registerTheme, applyTheme, defaultTheme as defaultThemeColors } from '../styles/themes';
import {
  agents as chatHubAgents,
  conversations as chatHubConversations,
  searchQuery as chatHubSearchQuery,
  selectedAgent as chatHubSelectedAgent,
  activeConv as chatHubActiveConv,
  sidebarOpen as chatHubSidebarOpen,
  loadingConvs as chatHubLoadingConvs,
  balance as chatHubBalance,
  msgs as chatHubMsgs,
  fetchInit as chatHubFetchInit,
  fetchMessages as chatHubFetchMessages,
  activeSessions as chatHubActiveSessions,
  loadingSessions as chatHubLoadingSessions,
  loadingAgents as chatHubLoadingAgents,
  fetchSessions as chatHubFetchSessions,
} from '../pages/ChatHubPage';

interface SidebarProps {
  mobileOpen?: boolean;
  onClose?: () => void;
}

/* ═══ SVG Icons ═══ */
const icons = {
  dashboard: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>
    </svg>
  ),
  machines: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
    </svg>
  ),
  chat: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
    </svg>
  ),
  tasks: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
    </svg>
  ),
  files: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/>
    </svg>
  ),
  wallet: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/><circle cx="18" cy="15" r="1"/>
    </svg>
  ),
  plug: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 2v6M8 2v6M16 2v6M5 8h14a1 1 0 011 1v2a6 6 0 01-6 6h0v5M13 17v5"/>
    </svg>
  ),
  package: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
    </svg>
  ),
  link: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/>
    </svg>
  ),
  settings: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
    </svg>
  ),
  tag: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>
    </svg>
  ),
  logout: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  ),
};

/* ═══ Vortex Logo (PNG) — agora usa TenantLogo dinâmico ═══ */
import { TenantLogo, tenantName } from './TenantLogo';
function VortexLogo({ size = 28 }: { size?: number }) {
  return <TenantLogo size={size} />;
}

/* ═══ ThemePicker — Modal de seleção de temas ═══ */
function ThemePicker({ open, onClose, themeId, setTheme, allThemes }: {
  open: boolean;
  onClose: () => void;
  themeId: string;
  setTheme: (id: string) => void;
  allThemes: Array<{ id: string; name: string; colors: any }>;
}) {
  const { t } = useTranslation('common');
  const [creatingTheme, setCreatingTheme] = useState(false);
  const [newThemeName, setNewThemeName] = useState('Meu Tema');
  const [pickedBg, setPickedBg] = useState(T.bgCard);
  const [pickedBgCard, setPickedBgCard] = useState(T.bgCard);
  const [pickedText, setPickedText] = useState('#E8E8F0');
  const [pickedTextSecondary, setPickedTextSecondary] = useState(T.textSecondary);
  const [pickedPrimary, setPickedPrimary] = useState(T.primary);
  const [pickedSuccess, setPickedSuccess] = useState(T.success);
  const [pickedDanger, setPickedDanger] = useState(T.danger);
  const [pickedBorder, setPickedBorder] = useState(T.border);

  if (!open) return null;

  const handleSaveCustomTheme = () => {
    const id = `custom-${Date.now()}`;
    const customColors = {
      ...defaultThemeColors,
      bg: pickedBg,
      bgCard: pickedBgCard,
      text: pickedText,
      textSecondary: pickedTextSecondary,
      primary: pickedPrimary,
      success: pickedSuccess,
      danger: pickedDanger,
      border: pickedBorder,
    };

    registerTheme(id, customColors);
    applyTheme(id);
    setCreatingTheme(false);
    onClose();
  };

  const previewColors = {
    bg: pickedBg,
    bgCard: pickedBgCard,
    text: pickedText,
    textSecondary: pickedTextSecondary,
    primary: pickedPrimary,
    success: pickedSuccess,
    danger: pickedDanger,
    border: pickedBorder,
    warning: T.warning,
    accent: T.accent,
    textMuted: pickedTextSecondary,
    radiusMd: 8,
  };

  return (
    <>
      {/* Overlay */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: T.bgOverlay, zIndex: 998,
          animation: 'fadeIn 0.15s ease',
        }}
      />

      {/* Modal */}
      <div style={{
        position: 'fixed', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        background: T.bgModal, borderRadius: 16,
        border: `1px solid ${T.border}`,
        boxShadow: T.shadowXl, zIndex: 999,
        maxWidth: 480, width: '90%', maxHeight: '80vh', overflow: 'auto',
        animation: 'fadeIn 0.2s ease',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '16px 20px', borderBottom: `1px solid ${T.border}`,
        }}>
          <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text, margin: 0 }}>
            {creatingTheme ? t('sidebar.create_custom_theme') : t('sidebar.choose_theme')}
          </h3>
          <Button variant="ghost"
            onClick={() => {
              if (creatingTheme) {
                setCreatingTheme(false);
              } else {
                onClose();
              }
            }}
            style={{
              background: 'transparent', border: 'none', color: T.textMuted,
              fontSize: 20, cursor: 'pointer', padding: 0, width: 24, height: 24,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            ✕
          </Button>
        </div>

        {/* Grid de temas OU tela de criação */}
        <div style={{ padding: 20 }}>
          {!creatingTheme ? (
            <>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: 12,
              }}>
                {allThemes.map((t) => {
                  const isActive = t.id === themeId;
                  return (
                    <div
                      key={t.id}
                      onClick={() => {
                        setTheme(t.id);
                        onClose();
                      }}
                      style={{
                        cursor: 'pointer',
                        borderRadius: 8,
                        border: isActive ? `2px solid ${T.primary}` : `1px solid ${T.border}`,
                        overflow: 'hidden',
                        transition: 'all 0.15s ease',
                        background: t.colors.bg,
                        position: 'relative',
                      }}
                      onMouseEnter={(e: any) => {
                        if (!isActive) e.currentTarget.style.borderColor = T.borderHover;
                      }}
                      onMouseLeave={(e: any) => {
                        if (!isActive) e.currentTarget.style.borderColor = T.border;
                      }}
                    >
                      {/* Mini preview card */}
                      <div style={{ padding: 8, minHeight: 70 }}>
                        {/* Header bar com 3 dots */}
                        <div style={{ display: 'flex', gap: 3, marginBottom: 6 }}>
                          <div style={{ width: 4, height: 4, borderRadius: '50%', background: t.colors.danger }} />
                          <div style={{ width: 4, height: 4, borderRadius: '50%', background: t.colors.warning }} />
                          <div style={{ width: 4, height: 4, borderRadius: '50%', background: t.colors.success }} />
                        </div>

                        {/* Sidebar + content mock */}
                        <div style={{ display: 'flex', gap: 4 }}>
                          {/* Mini sidebar */}
                          <div style={{
                            width: 16, borderRadius: 2,
                            background: t.colors.bgCard || t.colors.bgSecondary,
                            padding: 3, display: 'flex', flexDirection: 'column', gap: 2,
                          }}>
                            <div style={{ height: 2, borderRadius: 1, background: t.colors.primary, width: '100%' }} />
                            <div style={{ height: 2, borderRadius: 1, background: t.colors.textMuted, width: '70%', opacity: 0.4 }} />
                            <div style={{ height: 2, borderRadius: 1, background: t.colors.textMuted, width: '85%', opacity: 0.4 }} />
                          </div>

                          {/* Content area */}
                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
                            <div style={{ height: 4, borderRadius: 2, background: t.colors.text, width: '60%', opacity: 0.7 }} />
                            <div style={{ height: 10, borderRadius: 2, background: t.colors.primary, width: '50%' }} />
                            <div style={{
                              height: 12, borderRadius: t.colors.radiusMd || 4,
                              border: `1px solid ${t.colors.border}`,
                              background: t.colors.bgCard || 'transparent',
                            }} />
                            <div style={{ display: 'flex', gap: 2 }}>
                              <div style={{ height: 3, borderRadius: 2, background: t.colors.success, width: '30%' }} />
                              <div style={{ height: 3, borderRadius: 2, background: t.colors.accent || t.colors.purple, width: '25%' }} />
                              <div style={{ height: 3, borderRadius: 2, background: t.colors.warning, width: '20%' }} />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Label */}
                      <div style={{
                        padding: '6px 8px',
                        borderTop: `1px solid ${t.colors.border}`,
                        background: t.colors.bgCard || T.bgOverlay,
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      }}>
                        <span style={{ fontSize: 11, fontWeight: 600, color: t.colors.text }}>
                          {t.name}
                        </span>
                        {isActive && (
                          <span style={{
                            fontSize: 8, padding: '1px 5px', borderRadius: 99,
                            background: T.primary, color: T.text, fontWeight: 700,
                          }}>✓</span>
                        )}
                      </div>
                    </div>
                  );
                })}

                {/* Botão "+ Criar Tema" */}
                <div
                  onClick={() => setCreatingTheme(true)}
                  style={{
                    cursor: 'pointer',
                    borderRadius: 8,
                    border: `2px dashed ${T.border}`,
                    overflow: 'hidden',
                    transition: 'all 0.15s ease',
                    background: T.bgCard,
                    minHeight: 110,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                  }}
                  onMouseEnter={(e: any) => {
                    e.currentTarget.style.borderColor = T.primary;
                    e.currentTarget.style.background = T.bgCardHover;
                  }}
                  onMouseLeave={(e: any) => {
                    e.currentTarget.style.borderColor = T.border;
                    e.currentTarget.style.background = T.bgCard;
                  }}
                >
                  <span style={{ fontSize: 24, opacity: 0.6 }}>+</span>
                  <span style={{ fontSize: 11, fontWeight: 600, color: T.textSecondary }}>
                    {t('sidebar.create_theme')}
                  </span>
                </div>
              </div>

              {/* Footer info */}
              <div style={{
                marginTop: 16, padding: 12, background: T.bgOverlay,
                borderRadius: 8, border: `1px solid ${T.border}`,
              }}>
                <p style={{ fontSize: 11, color: T.textSecondary, margin: 0, lineHeight: 1.6 }}>
                  {t('sidebar.theme_tip', { count: allThemes.length })}
                </p>
              </div>
            </>
          ) : (
            <>
              {/* Tela de criação de tema */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                {/* Campo Nome */}
                <div>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: T.textSecondary, marginBottom: 6 }}>
                    {t('sidebar.theme_name')}
                  </label>
                  <Input
                    value={newThemeName}
                    onChange={(v) => setNewThemeName(v)}
                    placeholder="Ex: Meu Tema Escuro"
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      background: T.bgInput,
                      borderRadius: 8,
                      fontSize: 14,
                    }}
                  />
                </div>

                {/* Color Pickers - 2 colunas, 4 linhas */}
                <div>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: T.textSecondary, marginBottom: 8 }}>
                    {t('sidebar.main_colors')}
                  </label>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    {/* Fundo */}
                    <div>
                      <label style={{ display: 'block', fontSize: 11, color: T.textMuted, marginBottom: 4 }}>
                        {t('sidebar.background')}
                      </label>
                      <input
                        type="color"
                        value={pickedBg}
                        onChange={(e: any) => setPickedBg(e.target.value)}
                        style={{ width: '100%', height: 40, border: `1px solid ${T.border}`, borderRadius: 6, cursor: 'pointer' }}
                      />
                    </div>

                    {/* Fundo Card */}
                    <div>
                      <label style={{ display: 'block', fontSize: 11, color: T.textMuted, marginBottom: 4 }}>
                        {t('sidebar.background_card')}
                      </label>
                      <input
                        type="color"
                        value={pickedBgCard}
                        onChange={(e: any) => setPickedBgCard(e.target.value)}
                        style={{ width: '100%', height: 40, border: `1px solid ${T.border}`, borderRadius: 6, cursor: 'pointer' }}
                      />
                    </div>

                    {/* Texto */}
                    <div>
                      <label style={{ display: 'block', fontSize: 11, color: T.textMuted, marginBottom: 4 }}>
                        {t('sidebar.text')}
                      </label>
                      <input
                        type="color"
                        value={pickedText}
                        onChange={(e: any) => setPickedText(e.target.value)}
                        style={{ width: '100%', height: 40, border: `1px solid ${T.border}`, borderRadius: 6, cursor: 'pointer' }}
                      />
                    </div>

                    {/* Texto Secundário */}
                    <div>
                      <label style={{ display: 'block', fontSize: 11, color: T.textMuted, marginBottom: 4 }}>
                        {t('sidebar.text_secondary')}
                      </label>
                      <input
                        type="color"
                        value={pickedTextSecondary}
                        onChange={(e: any) => setPickedTextSecondary(e.target.value)}
                        style={{ width: '100%', height: 40, border: `1px solid ${T.border}`, borderRadius: 6, cursor: 'pointer' }}
                      />
                    </div>

                    {/* Primária */}
                    <div>
                      <label style={{ display: 'block', fontSize: 11, color: T.textMuted, marginBottom: 4 }}>
                        {t('sidebar.primary')}
                      </label>
                      <input
                        type="color"
                        value={pickedPrimary}
                        onChange={(e: any) => setPickedPrimary(e.target.value)}
                        style={{ width: '100%', height: 40, border: `1px solid ${T.border}`, borderRadius: 6, cursor: 'pointer' }}
                      />
                    </div>

                    {/* Sucesso */}
                    <div>
                      <label style={{ display: 'block', fontSize: 11, color: T.textMuted, marginBottom: 4 }}>
                        {t('sidebar.success_color')}
                      </label>
                      <input
                        type="color"
                        value={pickedSuccess}
                        onChange={(e: any) => setPickedSuccess(e.target.value)}
                        style={{ width: '100%', height: 40, border: `1px solid ${T.border}`, borderRadius: 6, cursor: 'pointer' }}
                      />
                    </div>

                    {/* Perigo */}
                    <div>
                      <label style={{ display: 'block', fontSize: 11, color: T.textMuted, marginBottom: 4 }}>
                        {t('sidebar.danger_color')}
                      </label>
                      <input
                        type="color"
                        value={pickedDanger}
                        onChange={(e: any) => setPickedDanger(e.target.value)}
                        style={{ width: '100%', height: 40, border: `1px solid ${T.border}`, borderRadius: 6, cursor: 'pointer' }}
                      />
                    </div>

                    {/* Borda */}
                    <div>
                      <label style={{ display: 'block', fontSize: 11, color: T.textMuted, marginBottom: 4 }}>
                        {t('sidebar.border_color')}
                      </label>
                      <input
                        type="color"
                        value={pickedBorder}
                        onChange={(e: any) => setPickedBorder(e.target.value)}
                        style={{ width: '100%', height: 40, border: `1px solid ${T.border}`, borderRadius: 6, cursor: 'pointer' }}
                      />
                    </div>
                  </div>
                </div>

                {/* Preview ao vivo */}
                <div>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: T.textSecondary, marginBottom: 8 }}>
                    {t('sidebar.preview')}
                  </label>
                  <div style={{
                    borderRadius: 8,
                    border: `1px solid ${previewColors.border}`,
                    overflow: 'hidden',
                    background: previewColors.bg,
                  }}>
                    <div style={{ padding: 12 }}>
                      {/* Header bar com 3 dots */}
                      <div style={{ display: 'flex', gap: 4, marginBottom: 8 }}>
                        <div style={{ width: 6, height: 6, borderRadius: '50%', background: previewColors.danger }} />
                        <div style={{ width: 6, height: 6, borderRadius: '50%', background: previewColors.warning }} />
                        <div style={{ width: 6, height: 6, borderRadius: '50%', background: previewColors.success }} />
                      </div>

                      {/* Sidebar + content mock */}
                      <div style={{ display: 'flex', gap: 6 }}>
                        {/* Mini sidebar */}
                        <div style={{
                          width: 24, borderRadius: 4,
                          background: previewColors.bgCard,
                          padding: 6, display: 'flex', flexDirection: 'column', gap: 4,
                        }}>
                          <div style={{ height: 3, borderRadius: 2, background: previewColors.primary, width: '100%' }} />
                          <div style={{ height: 3, borderRadius: 2, background: previewColors.textMuted, width: '70%', opacity: 0.5 }} />
                          <div style={{ height: 3, borderRadius: 2, background: previewColors.textMuted, width: '85%', opacity: 0.5 }} />
                        </div>

                        {/* Content area */}
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 4 }}>
                          <div style={{ height: 6, borderRadius: 3, background: previewColors.text, width: '60%', opacity: 0.8 }} />
                          <div style={{ height: 14, borderRadius: 4, background: previewColors.primary, width: '50%' }} />
                          <div style={{
                            height: 18, borderRadius: previewColors.radiusMd,
                            border: `1px solid ${previewColors.border}`,
                            background: previewColors.bgCard,
                          }} />
                          <div style={{ display: 'flex', gap: 3 }}>
                            <div style={{ height: 4, borderRadius: 2, background: previewColors.success, width: '30%' }} />
                            <div style={{ height: 4, borderRadius: 2, background: previewColors.accent, width: '25%' }} />
                            <div style={{ height: 4, borderRadius: 2, background: previewColors.warning, width: '20%' }} />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Label preview */}
                    <div style={{
                      padding: '8px 12px',
                      borderTop: `1px solid ${previewColors.border}`,
                      background: previewColors.bgCard,
                    }}>
                      <span style={{ fontSize: 12, fontWeight: 600, color: previewColors.text }}>
                        {newThemeName || 'Meu Tema'}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Botões */}
                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                  <Button variant="ghost"
                    onClick={() => setCreatingTheme(false)}
                    style={{
                      padding: '8px 16px',
                      background: T.bgHover,
                      border: `1px solid ${T.border}`,
                      borderRadius: 8,
                      color: T.textSecondary,
                      fontSize: 14,
                      fontWeight: 600,
                      cursor: 'pointer',
                      transition: 'all 0.15s ease',
                    }}
                  >
                    {t('cancel')}
                  </Button>
                  <Button variant="ghost"
                    onClick={handleSaveCustomTheme}
                    style={{
                      padding: '8px 16px',
                      background: T.primary,
                      border: 'none',
                      borderRadius: 8,
                      color: '#fff',
                      fontSize: 14,
                      fontWeight: 600,
                      cursor: 'pointer',
                      transition: 'all 0.15s ease',
                    }}
                  >
                    {t('sidebar.save_theme')}
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

/* ═══ Seção expandível estilo ChatGPT (Agentes / Seus chats) ═══ */
function ExpandableSection({ title, defaultOpen = false, children }: { title: string; defaultOpen?: boolean; children: any }) {
  const [open, setOpen] = useState(() => {
    const saved = localStorage.getItem(`sidebar_sec_${title}`);
    return saved !== null ? saved === 'open' : defaultOpen;
  });
  const toggle = () => {
    const next = !open;
    setOpen(next);
    localStorage.setItem(`sidebar_sec_${title}`, next ? 'open' : 'closed');
  };
  return (
    <div style={{ marginBottom: 2 }}>
      <div
        onClick={toggle}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '10px 16px', cursor: 'pointer', fontSize: 14, fontWeight: 500,
          color: T.text, transition: 'background 0.15s', borderRadius: 8,
          margin: '0 8px',
        }}
        onMouseEnter={(e: any) => { e.currentTarget.style.background = T.bgCardHover; }}
        onMouseLeave={(e: any) => { e.currentTarget.style.background = 'transparent'; }}
      >
        <span>{title}</span>
        <span style={{ fontSize: 12, color: T.textMuted, transform: open ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.2s', display: 'inline-block' }}>›</span>
      </div>
      {open && <div>{children}</div>}
    </div>
  );
}

export function Sidebar({ mobileOpen = false, onClose }: SidebarProps) {
  const { t, i18n } = useTranslation('common');
  const path = window.location.pathname;
  const { themeId, setTheme, allThemes } = useTheme();

  // Estado colapsado da sidebar (desktop only)
  const collapsed = !chatHubSidebarOpen.value && !mobileOpen;

  // Persistir estado no localStorage
  useEffect(() => {
    const saved = localStorage.getItem('chathub_sidebar_collapsed');
    if (saved === 'true') {
      chatHubSidebarOpen.value = false;
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('chathub_sidebar_collapsed', collapsed ? 'true' : 'false');
  }, [collapsed]);

  // Admin section states (mantidos como estavam)
  const [adminOpen, setAdminOpen] = useState(() => localStorage.getItem('sidebar_admin_unified') !== 'closed');
  const [newFeaturesOpen, setNewFeaturesOpen] = useState(() => localStorage.getItem('sidebar_newfeatures') !== 'closed');
  const [catsOpen, setCatsOpen] = useState(() => localStorage.getItem('sidebar_cats') !== 'closed');
  const [adminOverviewOpen, setAdminOverviewOpen] = useState(() => localStorage.getItem('sidebar_admin_overview') !== 'closed');
  const [adminCmsOpen, setAdminCmsOpen] = useState(() => localStorage.getItem('sidebar_admin_cms') !== 'closed');
  const [adminClientsOpen, setAdminClientsOpen] = useState(() => localStorage.getItem('sidebar_admin_clients') !== 'closed');
  const [adminInfraOpen, setAdminInfraOpen] = useState(() => localStorage.getItem('sidebar_admin_infra') !== 'closed');
  const [adminIntelOpen, setAdminIntelOpen] = useState(() => localStorage.getItem('sidebar_admin_intel') !== 'closed');
  const [adminChannelsOpen, setAdminChannelsOpen] = useState(() => localStorage.getItem('sidebar_admin_channels') !== 'closed');
  const [adminFinanceOpen, setAdminFinanceOpen] = useState(() => localStorage.getItem('sidebar_admin_finance') !== 'closed');
  const [adminSecurityOpen, setAdminSecurityOpen] = useState(() => localStorage.getItem('sidebar_admin_security') !== 'closed');
  const [adminSystemOpen, setAdminSystemOpen] = useState(() => localStorage.getItem('sidebar_admin_system') !== 'closed');
  const [adminOthersOpen, setAdminOthersOpen] = useState(() => localStorage.getItem('sidebar_admin_others') !== 'closed');
  const [hasConnectedRunners, setHasConnectedRunners] = useState(false);
  const [adminNotifCount, setAdminNotifCount] = useState(0);
  const [hasDevHub, setHasDevHub] = useState(false);
  const [userPlanName, setUserPlanName] = useState('Free');
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [helpSubmenuOpen, setHelpSubmenuOpen] = useState(false);
  const [langSubmenuOpen, setLangSubmenuOpen] = useState(false);
  const [themePickerOpen, setThemePickerOpen] = useState(false);
  const helpTimerRef = useRef<any>(null);
  const langTimerRef = useRef<any>(null);
  const openHelp = () => { if (helpTimerRef.current) clearTimeout(helpTimerRef.current); setHelpSubmenuOpen(true); };
  const closeHelpDelayed = () => { helpTimerRef.current = setTimeout(() => setHelpSubmenuOpen(false), 150); };
  const openLang = () => { if (langTimerRef.current) clearTimeout(langTimerRef.current); setLangSubmenuOpen(true); };
  const closeLangDelayed = () => { langTimerRef.current = setTimeout(() => setLangSubmenuOpen(false), 150); };

  // Idiomas principais para o submenu do perfil
  const FALLBACK_LANGS = [
    { code: 'pt-BR', name: 'Portuguese (Brazil)', native_name: 'Português (Brasil)', flag: '🇧🇷' },
    { code: 'en-US', name: 'English (US)', native_name: 'English (US)', flag: '🇺🇸' },
    { code: 'es-ES', name: 'Spanish (Spain)', native_name: 'Español (España)', flag: '🇪🇸' },
    { code: 'fr-FR', name: 'French (France)', native_name: 'Français (France)', flag: '🇫🇷' },
    { code: 'de-DE', name: 'German (Germany)', native_name: 'Deutsch (Deutschland)', flag: '🇩🇪' },
  ];
  const [featuredLangs, setFeaturedLangs] = useState(FALLBACK_LANGS);
  useEffect(() => {
    let cached = (window as any).__featuredLangsCache;
    if (cached) { setFeaturedLangs(cached); return; }
    fetch('/api/v1/public/i18n/featured-languages')
      .then(r => r.json())
      .then((data: any) => {
        if (Array.isArray(data) && data.length > 0) {
          (window as any).__featuredLangsCache = data;
          setFeaturedLangs(data);
        }
      })
      .catch(() => { /* usa fallback */ });
  }, []);
  const profileMenuRef = useRef<HTMLDivElement>(null);

  /* ═══ Notificações do usuário ═══ */
  const [notifUnreadCount, setNotifUnreadCount] = useState(0);
  const [notifPopoverOpen, setNotifPopoverOpen] = useState(false);
  const [notifItems, setNotifItems] = useState<any[]>([]);
  const [notifLoading, setNotifLoading] = useState(false);
  const notifRef = useRef<HTMLDivElement>(null);

  // Poll contagem de não lidas a cada 60s
  useEffect(() => {
    const fetchUnread = () => {
      api.get('/notification-inbox/unread-count').then((res: any) => {
        setNotifUnreadCount(res?.data?.count ?? res?.count ?? 0);
      }).catch(() => {});
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 60000);
    return () => clearInterval(interval);
  }, []);

  // Carregar notificações quando popover abre
  useEffect(() => {
    if (!notifPopoverOpen) return;
    setNotifLoading(true);
    api.get('/notification-inbox?limit=10').then((res: any) => {
      setNotifItems(res?.data?.notifications || res?.notifications || []);
    }).catch(() => {}).finally(() => setNotifLoading(false));
  }, [notifPopoverOpen]);

  // Fechar popover ao clicar fora
  useEffect(() => {
    if (!notifPopoverOpen) return;
    const handler = (e: MouseEvent) => {
      if (notifRef.current && !notifRef.current.contains(e.target as Node)) {
        setNotifPopoverOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [notifPopoverOpen]);

  const notifMarkAllRead = () => {
    api.patch('/notification-inbox/read-all', {}).then(() => {
      setNotifItems(prev => prev.map(n => ({ ...n, read: 1 })));
      setNotifUnreadCount(0);
    }).catch(() => {});
  };

  const notifHandleClick = (n: any) => {
    if (!n.read) {
      api.patch(`/notification-inbox/${n.id}/read`, {}).then(() => {
        setNotifItems(prev => prev.map(x => x.id === n.id ? { ...x, read: 1 } : x));
        setNotifUnreadCount(prev => Math.max(0, prev - 1));
      }).catch(() => {});
    }
    setNotifPopoverOpen(false);
    if (n.action_url) {
      if (n.action_url.startsWith('http')) window.open(n.action_url, '_blank');
      else route(n.action_url);
    }
  };

  // Tempo relativo para notificações
  const notifTimeAgo = (dateStr: string): string => {
    const diff = Math.floor((Date.now() - new Date(dateStr).getTime()) / 1000);
    if (diff < 60) return t('now');
    if (diff < 3600) return `${Math.floor(diff / 60)}min`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
    if (diff < 604800) return `${Math.floor(diff / 86400)}d`;
    return new Date(dateStr).toLocaleDateString('pt-BR');
  };

  // Ícone por categoria de notificação
  const notifCatIcon = (cat: string) => {
    const icons: Record<string, any> = {
      billing: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>,
      security: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
      promo: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/></svg>,
      system: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4"/></svg>,
    };
    return icons[cat] || <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></svg>;
  };

  // Carregar agentes e conversas do ChatHub ao montar sidebar
  useEffect(() => {
    chatHubFetchInit();
  }, []);

  // Check dev_hub feature + plan name
  useEffect(() => {
    if (isAdmin.value) { setHasDevHub(true); }
    api.get<any>('/subscription/me').then(res => {
      try {
        if (res?.plan?.name) setUserPlanName(res.plan.name);
        setHasDevHub(isAdmin.value || !!JSON.parse(res?.plan?.features || '{}').dev_hub);
      } catch { }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/runner-v3/list') as any;
        const runners = res?.data?.runners || [];
        const online = runners.some((r: any) => {
          if (r.status !== 'online' || !r.last_seen_at) return false;
          return Date.now() - new Date(r.last_seen_at).getTime() < 120_000;
        });
        setHasConnectedRunners(online);
      } catch (_) {}
    })();
  }, []);

  // Poll admin notification unread count
  useEffect(() => {
    if (!isAdmin.value) return;
    const fetchCount = () => {
      api.get('/admin/notifications/unread-count').then((res: any) => {
        setAdminNotifCount(res?.data?.count ?? res?.count ?? 0);
      }).catch(() => {});
    };
    fetchCount();
    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, []);

  // Close profile menu on click outside
  useEffect(() => {
    if (!profileMenuOpen) return;
    const handler = (e: MouseEvent) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(e.target as Node)) {
        setProfileMenuOpen(false);
        setHelpSubmenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [profileMenuOpen]);

  const toggleAdminUnified = () => {
    const next = !adminOpen;
    setAdminOpen(next);
    localStorage.setItem('sidebar_admin_unified', next ? 'open' : 'closed');
    if (!next) {
      const adminSubs = ['newfeatures', 'cats', 'admin_overview', 'admin_cms', 'admin_clients', 'admin_infra', 'admin_intel', 'admin_channels', 'admin_finance', 'admin_security', 'admin_system'] as const;
      const setters: Record<string, (v: boolean) => void> = {
        newfeatures: setNewFeaturesOpen, cats: setCatsOpen,
        admin_overview: setAdminOverviewOpen, admin_cms: setAdminCmsOpen, admin_clients: setAdminClientsOpen,
        admin_infra: setAdminInfraOpen, admin_intel: setAdminIntelOpen, admin_channels: setAdminChannelsOpen,
        admin_finance: setAdminFinanceOpen, admin_security: setAdminSecurityOpen, admin_system: setAdminSystemOpen,
      };
      for (const sub of adminSubs) {
        setters[sub](false);
        localStorage.setItem(`sidebar_${sub}`, 'closed');
      }
    }
  };

  // Seções admin — accordion (só uma aberta por vez)
  const adminSections: Record<string, (v: boolean) => void> = {
    admin_overview: setAdminOverviewOpen,
    admin_cms: setAdminCmsOpen,
    admin_clients: setAdminClientsOpen,
    admin_infra: setAdminInfraOpen,
    admin_intel: setAdminIntelOpen,
    admin_channels: setAdminChannelsOpen,
    admin_finance: setAdminFinanceOpen,
    admin_security: setAdminSecurityOpen,
    admin_system: setAdminSystemOpen,
    admin_others: setAdminOthersOpen,
  };

  const toggleSection = (section: string, current: boolean, setter: (v: boolean) => void) => {
    const next = !current;
    // Accordion: se é seção admin e está abrindo, fechar as outras
    if (next && section.startsWith('admin_') && adminSections[section]) {
      for (const [key, s] of Object.entries(adminSections)) {
        if (key !== section) {
          s(false);
          localStorage.setItem(`sidebar_${key}`, 'closed');
        }
      }
    }
    setter(next);
    localStorage.setItem(`sidebar_${section}`, next ? 'open' : 'closed');
  };

  const nav = (newPath: string) => {
    route(newPath);
    if (mobileOpen && onClose) onClose();
  };

  const isActive = (p: string) => {
    if (p === '/') return path === '/';
    // Match exato pra /chat (não ativar pra /chat/agent/xxx)
    if (p === '/chat') return path === '/chat' || (path.startsWith('/chat/') && !path.startsWith('/chat/agent'));
    return path.startsWith(p);
  };

  /* ═══ NavItem estilo ChatGPT — limpo, sem borderLeft ═══ */
  const NavItem = ({ to, icon, label, badge, indent }: { to: string; icon: any; label: string; badge?: any; indent?: boolean }) => (
    <div
      onClick={() => nav(to)}
      title={collapsed ? label : undefined}
      style={{
        display: 'flex', alignItems: 'center', gap: collapsed ? 0 : 12,
        padding: collapsed ? '8px 0' : (indent ? '8px 16px 8px 28px' : '8px 16px'),
        justifyContent: collapsed ? 'center' : 'flex-start',
        borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 400,
        color: isActive(to) ? T.text : T.textSecondary,
        background: isActive(to) ? T.bgHover : 'transparent',
        transition: 'background 0.15s',
        margin: collapsed ? '1px 4px' : '1px 8px',
      }}
      onMouseEnter={(e: any) => { if (!isActive(to)) e.currentTarget.style.background = T.bgCardHover; }}
      onMouseLeave={(e: any) => { if (!isActive(to)) e.currentTarget.style.background = 'transparent'; }}
    >
      <span style={{ width: 18, display: 'flex', justifyContent: 'center', flexShrink: 0, opacity: 0.85 }}>{icon}</span>
      {!collapsed && <span style={{ flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', opacity: 1, transition: 'opacity 0.15s' }}>{label}</span>}
      {!collapsed && badge}
    </div>
  );

  const SectionHeader = ({ label, open, onToggle, admin, isParent }: { label: string; open: boolean; onToggle: () => void; admin?: boolean; isParent?: boolean }) => (
    <div
      onClick={onToggle}
      style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: isParent ? '8px 14px' : '6px 14px', marginBottom: 4, cursor: 'pointer', userSelect: 'none',
        fontSize: 11, fontWeight: 700, color: isParent ? 'rgba(220,230,245,0.8)' : T.textMuted,
        textTransform: 'uppercase', letterSpacing: '0.8px',
      }}
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        {label}
        {isParent && <span style={{ fontSize: 9, fontWeight: 700, color: T.warning, background: T.warningBg, padding: '1px 5px', borderRadius: 4, letterSpacing: '0.5px', lineHeight: '14px' }}>{t('admin.title').toUpperCase()}</span>}
      </span>
      <span style={{ fontSize: 9, transition: 'transform 0.2s', transform: open ? 'rotate(0)' : 'rotate(-90deg)' }}>▼</span>
    </div>
  );

  const onlineDot = (
    <span style={{ width: 8, height: 8, borderRadius: '50%', background: T.success, animation: 'pulse 2s infinite', flexShrink: 0 }} />
  );

  /* ═══ Agentes estilo Telegram — avatar, nome, última msg, hora ═══ */
  const AgentsExpandableSection = () => {
    const allAgents = chatHubAgents.value.filter((a: any) => a.type !== 'elon_chat');
    // Ordenar por última mensagem (mais recente primeiro)
    const sorted = [...allAgents].sort((a: any, b: any) => {
      const ta = a.last_message_at ? new Date(a.last_message_at).getTime() : 0;
      const tb = b.last_message_at ? new Date(b.last_message_at).getTime() : 0;
      return tb - ta;
    });
    const MAX_VISIBLE = 8;
    const [showAll, setShowAll] = useState(false);
    const visibleAgents = showAll ? sorted : sorted.slice(0, MAX_VISIBLE);

    const formatTime = (iso: string) => {
      if (!iso) return '';
      const d = new Date(iso);
      const now = new Date();
      const diffMs = now.getTime() - d.getTime();
      const diffDays = Math.floor(diffMs / 86400000);
      if (diffDays === 0) return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
      if (diffDays === 1) return t('yesterday');
      if (diffDays < 7) return d.toLocaleDateString('pt-BR', { weekday: 'short' });
      return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
    };

    const openAgentMain = (agent: any) => {
      chatHubSelectedAgent.value = agent;
      const agentConvs = chatHubConversations.value.filter((c: any) =>
        agent.type === 'elon_chat'
          ? c.type === 'elon_chat'
          : c.type === 'openclaw' && c.workspace_id === agent.id
      );
      const sortedConvs = [...agentConvs].sort((a: any, b: any) =>
        new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
      );
      if (sortedConvs.length > 0) {
        chatHubActiveConv.value = sortedConvs[0];
        chatHubMsgs.value = [];
        chatHubFetchMessages(sortedConvs[0].id);
      } else {
        chatHubActiveConv.value = null;
        chatHubMsgs.value = [];
      }
      route(`/chat/agent/${agent.id}`);
      if (onClose) onClose();
    };

    const AgentAvatar = ({ agent, sz }: { agent: any; sz: number }) => {
      const avatarSrc = agent.avatar_url;
      if (avatarSrc) {
        return (
          <img src={avatarSrc} alt={agent.name}
            style={{ width: sz, height: sz, borderRadius: '50%', flexShrink: 0, objectFit: 'cover', display: 'block' }}
          />
        );
      }
      const initials = (agent.name || '?').charAt(0).toUpperCase();
      const colors = ['#6366f1', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981', '#3b82f6', '#ef4444'];
      const colorIdx = (agent.name || '').split('').reduce((a: number, c: string) => a + c.charCodeAt(0), 0) % colors.length;
      return (
        <div style={{
          width: sz, height: sz, borderRadius: '50%', flexShrink: 0,
          background: colors[colorIdx],
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: sz * 0.42, fontWeight: 700, color: '#fff',
        }}>
          {initials}
        </div>
      );
    };

    return (
      <ExpandableSection title={t('sidebar.agents_section')} defaultOpen={true}>
        {chatHubLoadingAgents.value ? (
          <div style={{ padding: '4px 8px' }}>
            {[1, 2, 3].map(i => (
              <div key={i} style={{
                display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', marginBottom: 2,
              }}>
                <div style={{ width: 42, height: 42, borderRadius: '50%', background: T.bgCard, flexShrink: 0, animation: 'skeletonPulse 1.5s ease-in-out infinite' }} />
                <div style={{ flex: 1 }}>
                  <div style={{ width: '60%', height: 12, background: T.bgCard, borderRadius: 4, marginBottom: 6, animation: 'skeletonPulse 1.5s ease-in-out infinite' }} />
                  <div style={{ width: '80%', height: 10, background: T.bgCard, borderRadius: 4, animation: 'skeletonPulse 1.5s ease-in-out infinite' }} />
                </div>
              </div>
            ))}
          </div>
        ) : visibleAgents.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '12px', color: T.textMuted, fontSize: 13 }}>
            {t('sidebar.no_agents')}
          </div>
        ) : <>
        {visibleAgents.map((agent: any) => {
          const isChatPage = window.location.pathname.startsWith('/chat');
          const isSelected = isChatPage && chatHubSelectedAgent.value?.id === agent.id;
          const lastMsg = agent.last_message || '';
          const lastTime = agent.last_message_at ? formatTime(agent.last_message_at) : '';
          return (
            <div
              key={agent.id + (agent.hash || '')}
              onClick={() => openAgentMain(agent)}
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '8px 10px',
                borderRadius: 10, cursor: 'pointer',
                background: isSelected ? T.bgHover : 'transparent',
                transition: 'background 0.15s ease',
                margin: '1px 6px',
              }}
              onMouseEnter={(e: any) => { if (!isSelected) e.currentTarget.style.background = T.bgCardHover; }}
              onMouseLeave={(e: any) => { e.currentTarget.style.background = isSelected ? T.bgHover : 'transparent'; }}
            >
              <AgentAvatar agent={agent} sz={42} />
              <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
                {/* Linha 1: Nome + Hora */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 4 }}>
                  <span style={{
                    fontSize: 13.5, fontWeight: 600, color: T.text,
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1,
                  }}>
                    {agent.name}
                  </span>
                  {lastTime && (
                    <span style={{ fontSize: 11, color: T.textSecondary, flexShrink: 0, fontWeight: 400 }}>
                      {lastTime}
                    </span>
                  )}
                </div>
                {/* Linha 2: Preview da última mensagem */}
                <div style={{
                  fontSize: 12, color: T.textSecondary, marginTop: 2,
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                  opacity: 0.7,
                }}>
                  {lastMsg || <span style={{ fontStyle: 'italic', opacity: 0.5 }}>{t('sidebar.no_messages')}</span>}
                </div>
              </div>
            </div>
          );
        })}
        {sorted.length > MAX_VISIBLE && !showAll && (
          <div
            onClick={() => setShowAll(true)}
            style={{
              padding: '8px 16px', fontSize: 12, color: T.textMuted, cursor: 'pointer',
              margin: '2px 6px', borderRadius: 8, transition: 'background 0.15s',
            }}
            onMouseEnter={(e: any) => { e.currentTarget.style.background = T.bgCardHover; }}
            onMouseLeave={(e: any) => { e.currentTarget.style.background = 'transparent'; }}
          >
            {t('sidebar.see_all_agents', { count: sorted.length })}
          </div>
        )}
        </>}
      </ExpandableSection>
    );
  };

  /* ═══ Chats recentes expandível (como "Seus chats" do ChatGPT) ═══ */
  const ChatsExpandableSection = () => {
    const allConvs = chatHubConversations.value.filter((c: any) => c.type === 'elon_chat' || !c.type);
    const MAX_VISIBLE = 5;
    const [showAllChats, setShowAllChats] = useState(false);

    const selectConv = (conv: any) => {
      chatHubActiveConv.value = conv;
      chatHubMsgs.value = [];
      chatHubFetchMessages(conv.id);
      route(`/chat/${conv.id}`);
      if (onClose) onClose();
    };

    const formatTimeAgo = (ts: string) => {
      const d = Date.now() - new Date(ts).getTime();
      if (d < 60000) return t('now');
      if (d < 3600000) return `${Math.floor(d / 60000)}min`;
      if (d < 86400000) return `${Math.floor(d / 3600000)}h`;
      return `${Math.floor(d / 86400000)}d`;
    };

    const visibleConvs = showAllChats ? allConvs : allConvs.slice(0, MAX_VISIBLE);

    return (
      <ExpandableSection title={t('sidebar.your_chats')} defaultOpen={false}>
        {chatHubLoadingConvs.value ? (
          <div style={{ padding: '8px 16px' }}>
            {[1, 2, 3].map(i => (
              <div key={i} style={{
                height: 32, borderRadius: 8, marginBottom: 6,
                background: T.bgCard,
                animation: 'skeletonPulse 1.5s ease-in-out infinite',
                animationDelay: `${i * 0.2}s`,
              }} />
            ))}
          </div>
        ) : visibleConvs.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '16px 12px', color: T.textMuted, fontSize: 13 }}>
            {t('sidebar.no_conversations')}
          </div>
        ) : (
          <>
            {visibleConvs.map((conv: any, idx: number) => {
              const isActive = chatHubActiveConv.value?.id === conv.id;
              return (
                <div
                  key={conv.id}
                  onClick={() => selectConv(conv)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 10, padding: '7px 16px',
                    borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 400,
                    color: isActive ? T.text : T.textSecondary,
                    background: isActive ? T.bgHover : 'transparent',
                    transition: 'background 0.15s ease, color 0.15s ease, transform 0.15s ease', margin: '1px 8px',
                  }}
                  onMouseEnter={(e: any) => { if (!isActive) e.currentTarget.style.background = T.bgCardHover; }}
                  onMouseLeave={(e: any) => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}
                >
                  <span style={{ opacity: 0.5, flexShrink: 0, display: 'flex', alignItems: 'center' }}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg></span>
                  <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {conv.title || t('sidebar.new_conversation')}
                  </span>
                  <span style={{ fontSize: 11, color: T.textMuted, flexShrink: 0 }}>{formatTimeAgo(conv.updated_at)}</span>
                </div>
              );
            })}
            {allConvs.length > MAX_VISIBLE && !showAllChats && (
              <div
                onClick={() => setShowAllChats(true)}
                style={{
                  padding: '6px 16px', fontSize: 13, color: T.textMuted, cursor: 'pointer',
                  margin: '0 8px', borderRadius: 8, transition: 'background 0.15s',
                }}
                onMouseEnter={(e: any) => { e.currentTarget.style.background = T.bgCardHover; }}
                onMouseLeave={(e: any) => { e.currentTarget.style.background = 'transparent'; }}
              >
                {t('sidebar.see_all_chats', { remaining: allConvs.length - MAX_VISIBLE })}
              </div>
            )}
            {showAllChats && allConvs.length > MAX_VISIBLE && (
              <div
                onClick={() => setShowAllChats(false)}
                style={{
                  padding: '6px 16px', fontSize: 13, color: T.textMuted, cursor: 'pointer',
                  margin: '0 8px', borderRadius: 8, transition: 'background 0.15s',
                }}
                onMouseEnter={(e: any) => { e.currentTarget.style.background = T.bgCardHover; }}
                onMouseLeave={(e: any) => { e.currentTarget.style.background = 'transparent'; }}
              >
                {t('show_less')}
              </div>
            )}
          </>
        )}
      </ExpandableSection>
    );
  };

  return (
    <>
      {mobileOpen && <div class="sidebar-backdrop visible" onClick={() => onClose?.()} />}

      <nav class={`sidebar ${mobileOpen ? 'open' : ''}`} style={{
        background: CT.sidebar.bg, overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100dvh',
        width: mobileOpen ? undefined : (collapsed ? 60 : 260),
        minWidth: mobileOpen ? undefined : (collapsed ? 60 : 260),
        transition: mobileOpen ? undefined : 'width 0.2s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
      }}>
        {/* ═══ ZONA FIXA TOPO ═══ */}
        <div style={{ flexShrink: 0 }}>

          {/* Logo + Toggle */}
          <div style={{ padding: collapsed ? '6px 0 6px' : '6px 16px 6px', display: 'flex', alignItems: 'center', justifyContent: collapsed ? 'center' : 'space-between', flexDirection: collapsed ? 'column' : 'row', gap: collapsed ? 8 : 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: collapsed ? 'center' : 'flex-start' }}>
              <VortexLogo size={28} />
              {!collapsed && <span style={{ fontSize: 16, fontWeight: 700, color: T.text, letterSpacing: '-0.3px', whiteSpace: 'nowrap' }}>{tenantName()}</span>}
            </div>
            {mobileOpen ? (
              /* Mobile: botão fechar (X) */
              <div
                onClick={() => { if (onClose) onClose(); }}
                title={t("sidebar.close_menu")}
                style={{
                  width: 28, height: 28, borderRadius: 6, cursor: 'pointer',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: T.textMuted, background: 'transparent',
                  border: `1px solid rgba(255,255,255,0.12)`, padding: 0,
                  flexShrink: 0,
                }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </div>
            ) : (
              /* Desktop: botão colapsar (□) */
              <div
                onClick={() => { chatHubSidebarOpen.value = !chatHubSidebarOpen.value; }}
                title={collapsed ? t('sidebar.expand_sidebar') : t('sidebar.collapse_sidebar')}
                style={{
                  width: 28, height: 28, borderRadius: 6, cursor: 'pointer',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: T.textMuted, transition: 'background 0.15s',
                }}
                onMouseEnter={(e: any) => { e.currentTarget.style.background = T.bgHover; }}
                onMouseLeave={(e: any) => { e.currentTarget.style.background = 'transparent'; }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2"/><line x1="9" y1="3" x2="9" y2="21"/>
                </svg>
              </div>
            )}
          </div>

          {/* Itens fixos — diretos, com ícones SVG profissionais */}
          <NavItem to="/agents" icon={icons.machines} label={t("sidebar.manage_agents")} />
          <NavItem to="/chat" icon={icons.chat} label={t("sidebar.new_chat")} />
          <NavItem to="/integrations" icon={icons.plug} label={t("sidebar.integrations")} />
          {/* Indique & Ganhe movido para Novas Features (admin only) */}

          {/* Separador */}
          {!collapsed && <div style={{ height: 1, background: T.border, margin: '8px 16px' }} />}

        </div>{/* Fim ZONA FIXA TOPO */}

        {/* ═══ ZONA SCROLLÁVEL ═══ */}
        <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', minHeight: 0 }}>

          {/* Agentes expandível — escondido quando colapsado */}
          {!collapsed && <AgentsExpandableSection />}

          {/* Seus chats expandível — escondido quando colapsado */}
          {!collapsed && <ChatsExpandableSection />}

          {/* Saldo removido do menu principal — fica no Admin/Wallet */}

          {/* Separador antes do Admin */}
          {isAdmin.value && !collapsed && (
            <div style={{ height: 1, background: T.border, margin: '8px 16px' }} />
          )}

          {/* ═══ ADMIN (escondido quando colapsado) ═══ */}
          {isAdmin.value && !collapsed && (
          <div style={{ padding: '0 10px', marginBottom: 4 }}>
            <SectionHeader label={t("admin.title")} open={adminOpen} onToggle={() => toggleAdminUnified()} isParent />
            {adminOpen && (<div style={{ maxHeight: 'calc(100vh - 400px)', overflowY: 'auto', overflowX: 'hidden' }}>

            {/* ── NOVAS FEATURES (+ Dev Hub adicionado) ── */}
            <div style={{ padding: '0 0px', marginBottom: 4 }}>
              <SectionHeader label={t("admin.new_features")} open={newFeaturesOpen} onToggle={() => toggleSection('newfeatures', newFeaturesOpen, setNewFeaturesOpen)} />
              {newFeaturesOpen && (<>
                <NavItem to="/chat" icon={icons.chat} label={t("sidebar.new_chat")} />
                <NavItem to="/ambientes" icon={<span style={{ fontSize: 16 }}></span>} label={t("admin:environments")} />
                {/* Carteira removida — integrada no Profile */}
                <NavItem to="/install-elon" icon={<span style={{ fontSize: 16 }}></span>} label={t("admin:connect_machine")} />
                <NavItem to="/orchestrator" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="6" r="3"/><circle cx="18" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="18" r="3"/><line x1="9" y1="6" x2="15" y2="6"/><line x1="6" y1="9" x2="6" y2="15"/><line x1="18" y1="9" x2="18" y2="15"/><line x1="9" y1="18" x2="15" y2="18"/></svg>} label={t("admin:orchestrator")} />
                <NavItem to="/" icon={icons.dashboard} label={t("admin:dashboard")} />
                <NavItem to="/runs" icon={icons.tasks} label={t("admin:tasks")} />
                <NavItem to="/files" icon={icons.files} label={t("admin:files")} />
                <NavItem to="/dev-mode" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>} label={t("admin:dev_mode")} />
                <NavItem to="/copilot" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l1.09 3.26L16.36 6.5l-3.27 1.09L12 10.86l-1.09-3.27L7.64 6.5l3.27-1.24L12 2z"/><path d="M5 15l.55 1.64L7.18 17.2l-1.63.55L5 19.38l-.55-1.63L2.82 17.2l1.63-.56L5 15z"/><path d="M19 12l.55 1.64 1.63.56-1.63.55L19 16.38l-.55-1.63-1.63-.55 1.63-.56L19 12z"/></svg>} label={t("admin:copilot")} />
                {/* Dev Hub — movido de Enterprise pra cá */}
                <NavItem to="/dev" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>} label={t("admin:dev_hub")} />
                <NavItem to="/admin/design" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="13.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="10.5" r="2.5"/><circle cx="8.5" cy="7.5" r="2.5"/><circle cx="6.5" cy="12.5" r="2.5"/><path d="M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10z"/></svg>} label={t("admin:dev_visual")} />
                <NavItem to="/referral" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>} label={t("admin:refer_earn")} badge={<span style={{ fontSize: 8, fontWeight: 700, background: T.warning, color: '#000', padding: '1px 5px', borderRadius: 4, letterSpacing: 0.5, lineHeight: '12px', marginLeft: 4 }}>{t('admin:new_badge')}</span>} />
              </>)}
            </div>

            {/* ── CATEGORIAS ── */}
            {categories.value.length > 0 && (
              <div style={{ padding: '0 0px', marginBottom: 4 }}>
                <SectionHeader label={t("admin.categories")} open={catsOpen} onToggle={() => toggleSection('cats', catsOpen, setCatsOpen)} />
                {catsOpen && categories.value.map((cat) => (
                  <NavItem key={cat.slug} to={`/categories/${cat.slug}`} icon={icons.tag} label={cat.name} />
                ))}
              </div>
            )}

            {/* ── VISÃO GERAL ── */}
            <div style={{ padding: '0 0px', marginBottom: 4 }}>
              <SectionHeader label={t("admin.overview")} open={adminOverviewOpen} onToggle={() => toggleSection('admin_overview', adminOverviewOpen, setAdminOverviewOpen)} />
              {adminOverviewOpen && <>
                <NavItem to="/admin" icon={icons.settings} label={t("admin:panel")} />
                <NavItem to="/admin/analytics" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18 20V10"/><path d="M12 20V4"/><path d="M6 20v-6"/></svg>} label={t("admin:analytics")} />
                <NavItem to="/admin/chat" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/><path d="M8 9h8"/><path d="M8 13h4"/></svg>} label={t("admin:chat_hub")} />
              </>}
            </div>

            {/* ── CMS ── */}
            <div style={{ padding: '0 0px', marginBottom: 4 }}>
              <SectionHeader label={t("admin.cms")} open={adminCmsOpen} onToggle={() => toggleSection('admin_cms', adminCmsOpen, setAdminCmsOpen)} />
              {adminCmsOpen && <>
                <NavItem to="/admin/cms" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>} label={t("admin.cms")} />
                <NavItem to="/admin/geo-modal" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>} label="🌍 Geo Modal" />
              </>}
            </div>

            {/* ── CLIENTES ── */}
            <div style={{ padding: '0 0px', marginBottom: 4 }}>
              <SectionHeader label={t("admin.clients")} open={adminClientsOpen} onToggle={() => toggleSection('admin_clients', adminClientsOpen, setAdminClientsOpen)} />
              {adminClientsOpen && <>
                <NavItem to="/admin/users" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>} label={t("admin:users")} />
                <NavItem to="/crm" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>} label={t("admin:crm")} />
                <NavItem to="/admin/subscriptions" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>} label={t("admin:subscriptions")} />
                <NavItem to="/admin/referrals" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4-4v-2"/><circle cx="8.5" cy="7" r="4"/><path d="M20 8v6"/><path d="M23 11h-6"/></svg>} label={t("admin:referrals")} />
              </>}
            </div>

            {/* ── INFRAESTRUTURA (super admin only) ── */}
            {isSuperAdmin.value && (
            <div style={{ padding: '0 0px', marginBottom: 4 }}>
              <SectionHeader label={t("admin.infrastructure")} open={adminInfraOpen} onToggle={() => toggleSection('admin_infra', adminInfraOpen, setAdminInfraOpen)} />
              {adminInfraOpen && <>
                <NavItem to="/admin/cluster" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><circle cx="4" cy="8" r="2"/><circle cx="20" cy="8" r="2"/><circle cx="4" cy="16" r="2"/><circle cx="20" cy="16" r="2"/><line x1="6" y1="8" x2="9.5" y2="10.5"/><line x1="14.5" y1="10.5" x2="18" y2="8"/><line x1="6" y1="16" x2="9.5" y2="13.5"/><line x1="14.5" y1="13.5" x2="18" y2="16"/></svg>} label={t("admin:cluster")} />
                <NavItem to="/admin/capacity-planning" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>} label={t("admin:capacity")} />
                <NavItem to="/admin/servers" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="8" rx="2"/><rect x="2" y="14" width="20" height="8" rx="2"/><line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/></svg>} label={t("admin:servers")} />
                <NavItem to="/admin/runners-v2" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="8" rx="2"/><rect x="2" y="14" width="20" height="8" rx="2"/><circle cx="6" cy="6" r="1"/><circle cx="6" cy="18" r="1"/></svg>} label={t("admin:runners_v2")} />
                <NavItem to="/admin/runners" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>} label={t("admin:runners")} />
                <NavItem to="/admin/snapshots" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>} label={t("admin:snapshots")} />
                <NavItem to="/admin/orchestrator" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="6" r="3"/><circle cx="18" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="18" r="3"/><line x1="9" y1="6" x2="15" y2="6"/><line x1="6" y1="9" x2="6" y2="15"/><line x1="18" y1="9" x2="18" y2="15"/><line x1="9" y1="18" x2="15" y2="18"/></svg>} label={t("admin:orchestrator")} />
                <NavItem to="/admin/cronjobs" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>} label={t("admin:job_queue")} />
                <NavItem to="/admin/notifications" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></svg>} label={t("admin:notifications")} badge={adminNotifCount > 0 ? <span style={{ background: T.danger, color: T.text, fontSize: 10, fontWeight: 700, padding: '1px 6px', borderRadius: 10, minWidth: 16, textAlign: 'center' }}>{adminNotifCount}</span> : undefined} />
              </>}
            </div>
            )}

            {/* ── INTELIGÊNCIA (super admin only) ── */}
            {isSuperAdmin.value && (
            <div style={{ padding: '0 0px', marginBottom: 4 }}>
              <SectionHeader label={t("admin.intelligence")} open={adminIntelOpen} onToggle={() => toggleSection('admin_intel', adminIntelOpen, setAdminIntelOpen)} />
              {adminIntelOpen && <>
                <NavItem to="/admin/brain" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a9 9 0 0 1 9 9c0 3.88-2.46 7.19-5.9 8.45"/><path d="M12 2a9 9 0 0 0-9 9c0 3.88 2.46 7.19 5.9 8.45"/><path d="M12 2v20"/><path d="M4.5 10.5h15"/></svg>} label={t("admin:brain")} />
                <NavItem to="/admin/agents" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 00-16 0"/></svg>} label={t("admin:agents")} />
                <NavItem to="/skills-center" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>} label={t("admin:skills")} />
                <NavItem to="/admin/usage" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>} label={t("admin:llm_usage")} />
                <NavItem to="/admin/elon-router" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>} label={t("admin:router")} />
                <NavItem to="/admin/llm-test" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v18m0 0h10a2 2 0 002-2V9M9 21H5a2 2 0 01-2-2V9m0 0h18"/></svg>} label={t("admin:llm_test")} />
              </>}
            </div>
            )}

            {/* ── CANAIS ── */}
            <div style={{ padding: '0 0px', marginBottom: 4 }}>
              <SectionHeader label={t("admin.channels")} open={adminChannelsOpen} onToggle={() => toggleSection('admin_channels', adminChannelsOpen, setAdminChannelsOpen)} />
              {adminChannelsOpen && <>
                <NavItem to="/whatsapp-connect" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg>} label={t("admin:whatsapp")} />
                <NavItem to="/admin/integrations" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v6M8 2v6M16 2v6M5 8h14a1 1 0 011 1v2a6 6 0 01-6 6h0v5M13 17v5"/></svg>} label={t("sidebar.integrations")} />
              </>}
            </div>

            {/* ── FINANCEIRO ── */}
            <div style={{ padding: '0 0px', marginBottom: 4 }}>
              <SectionHeader label={t("admin.finance")} open={adminFinanceOpen} onToggle={() => toggleSection('admin_finance', adminFinanceOpen, setAdminFinanceOpen)} />
              {adminFinanceOpen && <>
                <NavItem to="/admin/payment-gateways" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>} label={t("admin:payments")} />
                <NavItem to="/upgrade" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>} label={t("admin:plans")} />
                <NavItem to="/admin/promotions" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>} label={t("admin:promotions")} />
                <NavItem to="/admin/affiliates" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>} label={t("admin:affiliates")} />
              </>}
            </div>

            {/* ── SEGURANÇA (super admin only) ── */}
            {isSuperAdmin.value && (
            <div style={{ padding: '0 0px', marginBottom: 4 }}>
              <SectionHeader label={t("admin.security")} open={adminSecurityOpen} onToggle={() => toggleSection('admin_security', adminSecurityOpen, setAdminSecurityOpen)} />
              {adminSecurityOpen && <>
                <NavItem to="/admin/auth" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/><circle cx="12" cy="16" r="1"/></svg>} label={t("admin:auth")} />
                <NavItem to="/admin/compliance" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>} label={t("admin:compliance")} />
                <NavItem to="/vault-manager" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>} label={t("admin:vault")} />
                <NavItem to="/admin/intelligence" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/><path d="M8 12h8"/></svg>} label={t("admin:intelligence")} />
              </>}
            </div>
            )}

            {/* ── SISTEMA (super admin only) ── */}
            {isSuperAdmin.value && (
            <div style={{ padding: '0 0px', marginBottom: 4 }}>
              <SectionHeader label={t("admin.system")} open={adminSystemOpen} onToggle={() => toggleSection('admin_system', adminSystemOpen, setAdminSystemOpen)} />
              {adminSystemOpen && <>
                <NavItem to="/backups" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>} label={t("admin:backups")} />
                <NavItem to="/admin/files" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/></svg>} label={t("admin:files")} />
                <NavItem to="/admin/logs" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>} label={t("admin:logs")} />
                <NavItem to="/admin/optimizer" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>} label="⚡ Optimizer" />
                <NavItem to="/admin/idiomas" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>} label="🌍 Idiomas" />
              </>}
            </div>
            )}

            {/* ── WHITE LABEL / MARCA (tenant admin) ── */}
            <div style={{ padding: '0 0px', marginBottom: 4 }}>
              <div style={{ padding: '6px 12px', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: '#666', letterSpacing: '0.5px' }}>Marca</div>
              <NavItem to="/admin/branding" icon={<span style={{ fontSize: 16 }}>🎨</span>} label="Branding" />
              <NavItem to="/admin/domain" icon={<span style={{ fontSize: 16 }}>🌐</span>} label="Domínio" />
              <NavItem to="/admin/stripe" icon={<span style={{ fontSize: 16 }}>💳</span>} label="Pagamentos" />
              <NavItem to="/admin/team" icon={<span style={{ fontSize: 16 }}>👥</span>} label="Equipe" />
              {isSuperAdmin.value && (
                <NavItem to="/super-admin" icon={<span style={{ fontSize: 16 }}>🏢</span>} label="Super Admin" />
              )}
            </div>

            {/* ── OUTROS (super admin only) ── */}
            {isSuperAdmin.value && (
            <div style={{ padding: '0 0px', marginBottom: 4 }}>
              <SectionHeader label={t("admin.others")} open={adminOthersOpen} onToggle={() => toggleSection('admin_others', adminOthersOpen, setAdminOthersOpen)} />
              {adminOthersOpen && <>
                <NavItem to="/admin/bug-reports" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>} label={t("admin:bug_reports")} />
                <NavItem to="/admin/cloud" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z"/></svg>} label={t("admin:cloud_admin")} />
                <NavItem to="/admin/customers" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>} label={t("admin:customers")} />
                <NavItem to="/admin/database" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>} label={t("admin:database")} />
                <NavItem to="/admin/docker-images" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v3"/></svg>} label={t("admin:docker_images")} />
                <NavItem to="/admin/docs" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>} label={t("admin:docs")} />
                <NavItem to="/admin/flow" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>} label={t("admin:flow")} />
                <NavItem to="/admin/github" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"/></svg>} label={t("admin:github")} />
                <NavItem to="/admin/icons" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>} label={t("admin:icons")} />
                <NavItem to="/admin/sitemap" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="5" r="3"/><circle cx="5" cy="19" r="3"/><circle cx="19" cy="19" r="3"/><line x1="12" y1="8" x2="5" y2="16"/><line x1="12" y1="8" x2="19" y2="16"/></svg>} label={t("admin:sitemap")} />
                <NavItem to="/admin/seo" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>} label="🔍 SEO" />
                <NavItem to="/admin/skills" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>} label={t("admin:skills_page")} />
                <NavItem to="/admin/vault/audit-log" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>} label={t("admin:vault_audit")} />
                <NavItem to="/admin/wallets" icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><path d="M1 10h22"/><circle cx="18" cy="15" r="1"/></svg>} label={t("admin:wallets")} />
              </>}
            </div>
            )}

            </div>)}
          </div>
          )}

        </div>{/* Fim ZONA SCROLLÁVEL */}

        {/* Seletor de idioma removido — agora fica no menu do perfil */}

        {/* ═══ RODAPÉ: Avatar + Nome + Plano + Sino ═══ */}
        <div style={{ flexShrink: 0, background: CT.sidebar.bg, zIndex: 10 }} ref={profileMenuRef}>
          <div style={{ height: 1, background: T.border, margin: collapsed ? '0 8px' : '0 16px' }} />
          <div style={{ display: 'flex', flexDirection: collapsed ? 'column' : 'row', alignItems: 'center', gap: 0 }}>

            {/* ═══ Avatar + Nome (perfil) ═══ */}
            <div
              onClick={() => { setProfileMenuOpen(!profileMenuOpen); setHelpSubmenuOpen(false); setLangSubmenuOpen(false); setNotifPopoverOpen(false); }}
              title={collapsed ? (user.value?.name || 'Perfil') : undefined}
              style={{
                padding: collapsed ? '8px 0' : '10px 8px 10px 16px',
                flex: collapsed ? undefined : 1,
                justifyContent: 'center',
                background: profileMenuOpen ? T.border : 'transparent',
                cursor: 'pointer', transition: 'background 0.15s',
                display: 'flex', alignItems: 'center', gap: collapsed ? 0 : 10,
              }}
              onMouseEnter={(e: any) => { e.currentTarget.style.background = T.border; }}
              onMouseLeave={(e: any) => { if (!profileMenuOpen) e.currentTarget.style.background = 'transparent'; }}
            >
              <div style={{
                width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
                background: T.gradientPrimary,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 12, fontWeight: 700, color: T.text,
              }}>
                {(user.value?.name || user.value?.email || '?')[0].toUpperCase()}
              </div>
              {!collapsed && (
                <div style={{ overflow: 'hidden', flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 500, color: T.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '17px' }}>
                    {user.value?.name || user.value?.email?.split('@')[0] || 'Usuário'}
                  </div>
                  <div style={{ fontSize: 11, color: T.textMuted, whiteSpace: 'nowrap', lineHeight: '14px' }}>
                    {userPlanName}
                  </div>
                </div>
              )}
            </div>

            {/* ═══ Sino de Notificações (à direita / abaixo quando collapsed) ═══ */}
            <div ref={notifRef} style={{ position: 'relative', flexShrink: 0 }}>
              <div
                onClick={(e: any) => { e.stopPropagation(); setNotifPopoverOpen(!notifPopoverOpen); setProfileMenuOpen(false); }}
                title={t("notifications.title")}
                style={{
                  padding: collapsed ? '6px 0' : '8px', marginRight: collapsed ? 0 : 8,
                  cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  position: 'relative', transition: 'background 0.15s', borderRadius: 8,
                }}
                onMouseEnter={(e: any) => { e.currentTarget.style.background = T.border; }}
                onMouseLeave={(e: any) => { e.currentTarget.style.background = 'transparent'; }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={notifPopoverOpen ? T.primary : T.textMuted} stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/>
                </svg>
                {notifUnreadCount > 0 && (
                  <div style={{
                    position: 'absolute', top: 2, right: collapsed ? 2 : 4,
                    minWidth: 14, height: 14, borderRadius: 7,
                    background: T.danger, color: T.text, fontSize: 9, fontWeight: 700,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    padding: '0 3px', lineHeight: 1,
                  }}>
                    {notifUnreadCount > 99 ? '99+' : notifUnreadCount}
                  </div>
                )}
              </div>

              {/* Popover de Notificações — abre ACIMA do sino */}
              {notifPopoverOpen && (
                <div style={{
                  position: 'fixed', bottom: 64, left: 12,
                  width: 340, maxHeight: 480, background: 'var(--bg-card-solid, #1a1a2e)',
                  border: '1px solid rgba(255,255,255,0.12)', borderRadius: 14,
                  boxShadow: '0 12px 48px rgba(0,0,0,0.6)',
                  zIndex: 99999, animation: 'profileMenuIn 0.15s ease-out',
                  display: 'flex', flexDirection: 'column',
                }}>
                  {/* Header do popover */}
                  <div style={{ padding: '14px 16px 10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: 15, fontWeight: 600, color: T.text }}>{t('notifications.title')}</span>
                    {notifUnreadCount > 0 && (
                      <span
                        onClick={notifMarkAllRead}
                        style={{ fontSize: 12, color: T.primary, cursor: 'pointer', fontWeight: 500 }}
                        onMouseEnter={(e: any) => e.currentTarget.style.opacity = '0.7'}
                        onMouseLeave={(e: any) => e.currentTarget.style.opacity = '1'}
                      >
                        {t('notifications.mark_all_read')}
                      </span>
                    )}
                  </div>
                  <div style={{ height: 1, background: T.bgHover }} />

                  {/* Lista */}
                  <div style={{ flex: 1, overflowY: 'auto', maxHeight: 360 }}>
                    {notifLoading ? (
                      <div style={{ padding: 16 }}><SkeletonBar width="50%" height={14} style={{ marginBottom: 8 }} /><SkeletonBar width="30%" height={14} /></div>
                    ) : notifItems.length === 0 ? (
                      <div style={{ padding: 32, textAlign: 'center', color: T.textMuted, fontSize: 13 }}>{t('notifications.no_notifications')}</div>
                    ) : notifItems.map((n: any) => (
                      <div
                        key={n.id}
                        onClick={() => notifHandleClick(n)}
                        style={{
                          padding: '10px 16px', cursor: n.action_url ? 'pointer' : 'default',
                          display: 'flex', alignItems: 'flex-start', gap: 10,
                          background: !n.read ? T.primaryBg : 'transparent',
                          transition: 'background 0.15s',
                        }}
                        onMouseEnter={(e: any) => e.currentTarget.style.background = T.bgCardHover}
                        onMouseLeave={(e: any) => e.currentTarget.style.background = !n.read ? T.primaryBg : 'transparent'}
                      >
                        {/* Bolinha de não lida */}
                        <div style={{ width: 6, paddingTop: 6, flexShrink: 0 }}>
                          {!n.read && <div style={{ width: 6, height: 6, borderRadius: '50%', background: T.primary }} />}
                        </div>
                        {/* Ícone */}
                        <div style={{ flexShrink: 0, color: T.textMuted, paddingTop: 1 }}>{notifCatIcon(n.category)}</div>
                        {/* Conteúdo */}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: !n.read ? 600 : 400, color: T.text, lineHeight: '18px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {n.title}
                          </div>
                          <div style={{ fontSize: 12, color: T.textMuted, lineHeight: '16px', marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {n.message}
                          </div>
                        </div>
                        {/* Tempo */}
                        <div style={{ fontSize: 11, color: T.textMuted, flexShrink: 0, paddingTop: 2 }}>{notifTimeAgo(n.created_at)}</div>
                      </div>
                    ))}
                  </div>

                  <div style={{ height: 1, background: T.bgHover }} />
                  {/* Ver todas */}
                  <div
                    onClick={() => { setNotifPopoverOpen(false); route('/notifications'); }}
                    style={{ padding: '12px 16px', textAlign: 'center', fontSize: 13, color: T.primary, cursor: 'pointer', fontWeight: 500, transition: 'background 0.15s' }}
                    onMouseEnter={(e: any) => e.currentTarget.style.background = T.primaryBg}
                    onMouseLeave={(e: any) => e.currentTarget.style.background = 'transparent'}
                  >
                    {t('notifications.see_all')}
                  </div>
                </div>
              )}
            </div>

          </div>{/* Fim container avatar + sino */}

          {/* Dropdown — opens ABOVE pill */}
          {profileMenuOpen && (
            <div style={{
              position: 'fixed', bottom: 64, left: 12,
              width: 256, background: 'var(--bg-card-solid, #1a1a2e)',
              border: '1px solid rgba(255,255,255,0.12)', borderRadius: 14,
              boxShadow: '0 12px 48px rgba(0,0,0,0.6)',
              zIndex: 99999, animation: 'profileMenuIn 0.15s ease-out',
            }}>
              {/* Header */}
              <div style={{ padding: '14px 16px 12px', display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{
                  width: 34, height: 34, borderRadius: '50%', flexShrink: 0, background: T.gradientPrimary,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 14, fontWeight: 700, color: T.text,
                }}>
                  {(user.value?.name || user.value?.email || '?')[0].toUpperCase()}
                </div>
                <div style={{ overflow: 'hidden', flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: T.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {user.value?.name || 'Usuário'}
                  </div>
                  <div style={{ fontSize: 12, color: T.textMuted, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {user.value?.email || ''}
                  </div>
                </div>
              </div>

              <div style={{ height: 1, background: T.bgHover, margin: '0 8px' }} />

              <div style={{ padding: '4px 0' }}>
                {[
                  { label: t('profile_menu.upgrade_plan'), icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>, action: () => nav('/upgrade') },
                  { label: t('profile_menu.affiliates', 'Affiliates'), icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>, action: () => nav('/affiliates') },
                  { label: t('profile_menu.settings'), icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/></svg>, action: () => nav('/profile?tab=geral') },
                  { label: t('profile_menu.appearance'), icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="13.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="10.5" r="2.5"/><circle cx="8.5" cy="7.5" r="2.5"/><circle cx="6.5" cy="12.5" r="2.5"/><path d="M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10z"/></svg>, action: () => { setProfileMenuOpen(false); setThemePickerOpen(true); } },
                ].map((item) => (
                  <div key={item.label} onClick={() => { item.action(); setProfileMenuOpen(false); }}
                    style={{ padding: '10px 16px', cursor: 'pointer', fontSize: 14, color: T.text, display: 'flex', alignItems: 'center', gap: 12, transition: 'background 0.1s', borderRadius: 8, margin: '0 6px' }}
                    onMouseEnter={(e: any) => e.currentTarget.style.background = T.bgHover}
                    onMouseLeave={(e: any) => e.currentTarget.style.background = 'transparent'}
                  >
                    <span style={{ width: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', color: T.textMuted }}>{item.icon}</span>
                    {item.label}
                  </div>
                ))}

                {/* ═══ Submenu Idioma (estilo Claude) ═══ */}
                <div
                  onMouseEnter={openLang}
                  onMouseLeave={closeLangDelayed}
                  style={{ position: 'relative' }}
                >
                  <div style={{
                    padding: '10px 16px', cursor: 'pointer', fontSize: 14, color: T.text,
                    display: 'flex', alignItems: 'center', gap: 12, transition: 'background 0.1s',
                    background: langSubmenuOpen ? T.bgHover : 'transparent',
                    borderRadius: 8, margin: '0 6px',
                  }}
                    onMouseEnter={(e: any) => { e.currentTarget.style.background = T.bgHover; openLang(); }}
                    onMouseLeave={(e: any) => { if (!langSubmenuOpen) e.currentTarget.style.background = 'transparent'; }}
                  >
                    <span style={{ width: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', color: T.textMuted }}>🌐</span>
                    <span style={{ flex: 1 }}>{t('profile_menu.language') || 'Idioma'}</span>
                    <span style={{ fontSize: 11, color: T.textMuted }}>▸</span>
                  </div>

                  {langSubmenuOpen && (<>
                    {/* Ponte invisível entre menus */}
                    <div style={{ position: 'absolute', top: 0, right: -12, width: 12, height: '100%' }} />
                    <div
                      onMouseEnter={openLang}
                      onMouseLeave={closeLangDelayed}
                      style={{
                        position: 'fixed', left: 272, bottom: 120,
                        width: 240, maxHeight: 320, overflowY: 'auto',
                        background: 'var(--bg-card-solid, #1a1a2e)',
                        border: '1px solid rgba(255,255,255,0.12)', borderRadius: 14,
                        boxShadow: `0 8px 32px ${T.blackAlpha50}`, zIndex: 999999,
                        animation: 'profileMenuIn 0.12s ease-out', padding: '4px 0',
                      }}
                    >
                      {featuredLangs.map((lang: any) => {
                        const isActive = i18n.language === lang.code || i18n.language?.startsWith(lang.code?.split('-')[0]);
                        return (
                          <div
                            key={lang.code}
                            onClick={() => {
                              i18n.changeLanguage(lang.code);
                              document.cookie = `i18next=${lang.code};path=/;max-age=31536000`;
                              // Salvar preferência no perfil do usuário (best-effort)
                              const token = localStorage.getItem('token');
                              if (token) {
                                fetch('/api/v1/profile', {
                                  method: 'PUT',
                                  headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                                  body: JSON.stringify({ language: lang.code }),
                                }).catch(() => {});
                              }
                              setLangSubmenuOpen(false);
                              setProfileMenuOpen(false);
                            }}
                            style={{
                              padding: '10px 16px', cursor: 'pointer', fontSize: 14,
                              color: isActive ? T.primary : T.text,
                              display: 'flex', alignItems: 'center', gap: 10, transition: 'background 0.1s',
                              borderRadius: 8, margin: '0 6px',
                              fontWeight: isActive ? 600 : 400,
                              background: isActive ? T.primaryBg : 'transparent',
                            }}
                            onMouseEnter={(e: any) => e.currentTarget.style.background = T.bgHover}
                            onMouseLeave={(e: any) => e.currentTarget.style.background = 'transparent'}
                          >
                            <span style={{ fontSize: 16 }}>{lang.flag}</span>
                            <span style={{ flex: 1 }}>{lang.native_name}</span>
                            {isActive && <span style={{ color: T.primary, fontSize: 16 }}>✓</span>}
                          </div>
                        );
                      })}
                    </div>
                  </>)}
                </div>
              </div>

              <div style={{ height: 1, background: T.bgHover, margin: '0 8px' }} />

              {/* Ajuda with right-side submenu */}
              <div style={{ padding: '4px 0' }}>
                <div
                  onMouseEnter={openHelp}
                  onMouseLeave={closeHelpDelayed}
                  style={{ position: 'relative' }}
                >
                  <div style={{
                    padding: '10px 16px', cursor: 'pointer', fontSize: 14, color: T.text,
                    display: 'flex', alignItems: 'center', gap: 12, transition: 'background 0.1s',
                    background: helpSubmenuOpen ? T.bgHover : 'transparent',
                    borderRadius: 8, margin: '0 6px',
                  }}>
                    <span style={{ width: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', color: T.textMuted }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                    </span>
                    <span style={{ flex: 1 }}>{t('profile_menu.help')}</span>
                    <span style={{ fontSize: 11, color: T.textMuted }}>▸</span>
                  </div>

                  {helpSubmenuOpen && (<>
                    <div style={{
                      position: 'absolute', top: 0, right: -12, width: 12, height: '100%',
                    }} />
                    <div
                      onMouseEnter={openHelp}
                      onMouseLeave={closeHelpDelayed}
                      style={{
                      position: 'fixed', left: 272, bottom: 68,
                      width: 220, background: T.bgCard,
                      border: '1px solid rgba(255,255,255,0.12)', borderRadius: 14,
                      boxShadow: `0 8px 32px ${T.blackAlpha50}`, zIndex: 999999,
                      animation: 'profileMenuIn 0.12s ease-out', padding: '4px 0',
                    }}>
                      {[
                        { label: t('profile_menu.help_center'), icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>, action: () => window.open('/docs', '_blank') },
                        { label: t('profile_menu.terms_policies'), icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>, action: () => window.open('/terms', '_blank') },
                        { label: t('profile_menu.report_bug'), icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>, action: () => nav('/bug-report') },
                      ].map((item) => (
                        <div key={item.label} onClick={() => { item.action(); setProfileMenuOpen(false); setHelpSubmenuOpen(false); }}
                          style={{ padding: '10px 16px', cursor: 'pointer', fontSize: 14, color: T.text, display: 'flex', alignItems: 'center', gap: 12, transition: 'background 0.1s', borderRadius: 8, margin: '0 6px' }}
                          onMouseEnter={(e: any) => e.currentTarget.style.background = T.bgHover}
                          onMouseLeave={(e: any) => e.currentTarget.style.background = 'transparent'}
                        >
                          <span style={{ width: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', color: T.textMuted }}>{item.icon}</span>
                          {item.label}
                        </div>
                      ))}
                    </div>
                  </>)}
                </div>
              </div>

              <div style={{ height: 1, background: T.bgHover, margin: '0 8px' }} />

              <div style={{ padding: '4px 0' }}>
                <div onClick={() => { logout(); setProfileMenuOpen(false); }}
                  style={{ padding: '10px 16px', cursor: 'pointer', fontSize: 14, color: T.text, display: 'flex', alignItems: 'center', gap: 12, transition: 'background 0.1s', borderRadius: 8, margin: '0 6px' }}
                  onMouseEnter={(e: any) => e.currentTarget.style.background = T.bgHover}
                  onMouseLeave={(e: any) => e.currentTarget.style.background = 'transparent'}
                >
                  <span style={{ width: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', color: T.textMuted }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                  </span>
                  {t('profile_menu.logout')}
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>

      <style>{`@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }
@keyframes profileMenuIn { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: translateY(0); } }
@keyframes skeletonPulse { 0%, 100% { opacity: 0.4; } 50% { opacity: 0.15; } }
.sidebar::-webkit-scrollbar { width: 4px; }
.sidebar::-webkit-scrollbar-track { background: transparent; }
.sidebar::-webkit-scrollbar-thumb { background: var(--t-white-alpha-8); border-radius: 4px; }
.sidebar::-webkit-scrollbar-thumb:hover { background: ${T.whiteAlpha15}; }`}</style>

      {/* ThemePicker Modal */}
      <ThemePicker
        open={themePickerOpen}
        onClose={() => setThemePickerOpen(false)}
        themeId={themeId}
        setTheme={setTheme}
        allThemes={allThemes}
      />
    </>
  );
}
